import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RouteConfig from './services/routes/routes';
import { ErrorBoundary } from 'react-error-boundary';
import UploadProgressionBar from './components/UploadProgressionBar';
import ServerError from './views/ServerError';
import { logError } from "utils/logs";
import Toasts from './components/Toasts';
import './components/library/style/normalize.css';
import './components/library/style/reset.css';
import './components/library/style/typography.css';
import './components/library/style/animation.css';
function App() {
    return (_jsx("div", { className: "App", children: _jsxs(ErrorBoundary, { FallbackComponent: ServerError, onError: function (error, info) { return logError(error, info); }, children: [_jsx(RouteConfig, {}), _jsx(Toasts, {}), _jsx(UploadProgressionBar, {})] }) }));
}
export default App;
